var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconSwords = function SvgIconSwords(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#2A0A04"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m7.097 14.916.609-.61 2.12 2.12-.61.61 1.856 1.855-1.855 1.856-1.856-1.856-3.975 3.977-2.121-2.121 3.976-3.976-1.855-1.855L5.24 13.06zM20.615 14.916l-1.856 1.855 3.976 3.976-2.12 2.12-3.976-3.975-1.856 1.855-1.855-1.855 1.855-1.856-1.272-1.272 2.12-2.12 1.273 1.272 1.855-1.855zM22.47 5.374 11.337 16.506l-3.71-3.71L18.759 1.661 23 1.132zM5.241 1.663l6.043 6.043-3.71 3.71L1.53 5.375 1 1.133z"
  }))));
};
export default SvgIconSwords;